/* js/locationCard-accordion.js */

jQuery( document ).ready(function( $ ) {

    var numItems = $('.multiLocation-plugin .locationCard-accordion').length;
    
    console.log(numItems);
    
    if(numItems > 3){
        $('.footerMain').css('position', 'relative');
        $('.footerSpace').remove();
    }

});